import React from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import { Box, Typography, useTheme } from "@mui/material";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import { useAppSelector } from "../../../../hooks/useRedux";
import profileImage from "../../../../media/images/profileImage.png";
import CarTagView from "../../../components/CarTag";
import bigCar2 from "../../../../media/images/icons/bigcar2.svg";
import BoxCoveredIcon from "../../../../media/images/icons/box-covered";
import CustomAutoComple from "../../../components/CustomAutoComplete";
import InfoBox from "./InfoBox";
import SearchBox from "./SearchBox";
import CustomToggleButton from "../../../components/CustomToggleButton";
import NotifSwitch from "./NotifSwitch";
import FreightsList from "./FreightsList";

export default function GetFreight() {
  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const theme = useTheme();

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            انتخاب بار{" "}
          </Typography>
        }
        hasScroll={false}
      />
      <Box
        sx={{
          flex: "1",
          paddingX: "8px",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            border: "1px solid gray",
            padding: "10px",
            backgroundColor: "background.default",
            borderRadius: "10px",
          }}
        >
          <InfoBox />
          <SearchBox />
        </Box>
        <NotifSwitch />
        <FreightsList />
      </Box>

      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}
